module.exports = __webpack_public_path__ + "img/logo-aiDubbing-dark-mode.49471f4e.svg";